import Modal from "./Modal.component";

export default Modal;
